import React from 'react'
import DetailProducts from '../components/DetailProducts'
import Footer from '../components/Footer'
import ReviewSection from '../components/ReviewSection'

function ProductDetails() {
  return (
    <>
    <DetailProducts/>
    <ReviewSection />
    <Footer />
    </>
  )
}

export default ProductDetails
